import {
  Box,
  Button,
  Card,
  CardBody,
  Container,
  Heading,
  Image,
  List,
  ListIcon,
  ListItem,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiCheckCircle } from 'react-icons/fi'

export const GettingStartedPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={7}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={3}>
            👋 Начало работы
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Эта страница для нового сотрудника: как зайти в сервис и спокойно
            начать работать с первого дня.
          </Text>
        </Box>

        <Card>
          <CardBody>
            <Image src="/screenshots/app-login.png" alt="Экран входа" borderRadius="lg" mb={3} />
            <Text fontSize="sm" color="gray.600">Первый шаг — вход по логину и паролю, которые выдал администратор.</Text>
          </CardBody>
        </Card>

        <Box>
          <Heading size="md" mb={3}>Шаг 1. Вход</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Откройте сервис по рабочей ссылке вашей компании.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Введите e-mail и пароль.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Если не получается войти — используйте восстановление пароля.</ListItem>
          </List>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Шаг 2. Проверьте, что доступно именно вам</Heading>
          <Text color="gray.600" mb={2}>
            Сервис показывает разные разделы в зависимости от роли. Это нормально.
          </Text>
          <Button as={RouterLink} to="/users-and-roles" variant="outline">Открыть «Роли и доступы»</Button>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Шаг 3. Базовый рабочий цикл</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Откройте «График работ» и проверьте текущую неделю.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Проверьте объекты и бригады, с которыми вы работаете.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />В конце периода сформируйте отчёт.</ListItem>
          </List>
        </Box>

        <Box>
          <Button as={RouterLink} to="/schedule" mr={3}>Перейти к графику</Button>
          <Button as={RouterLink} to="/objects-and-blocks" variant="outline">Объекты и блоки</Button>
        </Box>
      </VStack>
    </Container>
  )
}
